class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initCard();
  }

  initCard() {
    const mainImage = this.querySelector('.main-image');
    const swatches = this.querySelectorAll('.color-swatch-btn');
    const productLink = this.querySelector('a.product-image-wrapper');

    if (!mainImage || !swatches.length) return;

    const activeColor = this.normalizeColor(this.getActiveColorFromURL());
    let defaultBtn = null;

    const setActive = (btn) => {
      if (!btn) return;

      swatches.forEach(s => s.classList.remove('active'));
      btn.classList.add('active');

      const newImage = btn.dataset.image;
      if (newImage && newImage !== mainImage.src) {
        this.fadeImage(mainImage, newImage);
      }

      const variantId = btn.dataset.variantId;
      if (variantId && productLink) {
        const base = productLink.href.split('?')[0];
        const newHref = `${base}?variant=${variantId}`;
        if (productLink.href !== newHref) {
          productLink.href = newHref;
        }
      }
    };

    // === שלב התאמת צבע URL לסווטץ' ===
    if (activeColor) {
      swatches.forEach(btn => {
        const colorName = this.normalizeColor(btn.dataset.optionValue);
        const taxonomyId = this.normalizeColor(btn.dataset.taxonomyId);
        if (
          colorName === activeColor ||
          taxonomyId === activeColor ||
          activeColor.includes(colorName) ||
          colorName.includes(activeColor)
        ) {
          defaultBtn = btn;
        }
      });
    }

    // === אם לא נמצא צבע מתאים, קח את הראשון המסומן או הראשון בכלל ===
    if (!defaultBtn) {
      defaultBtn = this.querySelector('.color-swatch-btn.active') || swatches[0];
    }

    // רק עכשיו הפעל את הסטייט
    if (defaultBtn) setActive(defaultBtn);

    // === מאזיני קליקים ===
    swatches.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setActive(btn);
      });
    });
  }

  getActiveColorFromURL() {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get('color') ||
      params.get('filter.v.t.shopify.color') ||
      params.get('filter.v.t.shopify.color-pattern') ||
      params.get('filter.v.t.shopify.צבע') ||
      params.get('filter.v.t.product.color-pattern') ||
      params.get('filter.v.t.product.color') ||
      params.get('filter.v.t.product.צבע') ||
      ''
    );
  }

  normalizeColor(str = '') {
    return str.toLowerCase().trim().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');
  }

  fadeImage(imgEl, newSrc) {
    if (!imgEl || !newSrc) return;
    imgEl.style.transition = 'opacity 0.3s ease';
    imgEl.style.opacity = 0;

    const tmp = new Image();
    tmp.onload = () => {
      imgEl.src = newSrc;
      requestAnimationFrame(() => {
        imgEl.style.opacity = 1;
      });
    };
    tmp.src = newSrc;
  }
}

customElements.define('product-card', ProductCard);
